import React, {useState} from 'react'
import {PageContainer, SearchBoxContainer} from '../../assets/styles/layout'
import RXRButton from '../RXRButton'
import PageHeader from '../PageHeader'
import ClearableInput from '../ClearableInput'
import {makeStyles} from '@mui/styles'
import {iconButtonSizeLarge, iconSizeLarge, spaceMedium} from '../../assets/styles/spacing'
import {generatePath, matchPath, useHistory, useLocation} from 'react-router-dom'
import Routes from '../../constants/RouteConstants'
import {useSelector} from 'react-redux'
import {IconButton} from '@mui/material'
import RXRIcon from '../RXRIcon'
import {iconButton} from '../../assets/styles/buttons'
import ListDocumentsAtBuildingTable from './ListDocumentsAtBuildingTable'
import SidePanel from '../SidePanel'
import CreateOrEditDocument from './CreateOrEditDocument'

function ResidentAppDocuments(props) {
  const classes = useStyles()
  const [filterTerm, setFilterTerm] = useState('')

  const history = useHistory()
  const {pathname} = useLocation()
  const defaultMatch = matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_DOCUMENTS_BY_BUILDING_VIEW_SINGLE})

  const createMatch = matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_DOCUMENTS_CREATE_BY_BUILDING_VIEW_SINGLE})
  const isCreateMode = !!createMatch

  const viewDocumentMatch = isCreateMode
    ? null
    : matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_DOCUMENTS_VIEW_SINGLE_BY_BUILDING_VIEW_SINGLE})
  const focusedDocumentId = viewDocumentMatch ? viewDocumentMatch.params.documentId : null

  const {buildingId} = (defaultMatch || createMatch || viewDocumentMatch).params

  const selectedBuilding = useSelector(state => state.GlobalAdmin.buildingsLookup[buildingId])

  const closeSidePanel = () => {
    history.push(generatePath(Routes.ADMIN_DASHBOARD_DOCUMENTS_BY_BUILDING_VIEW_SINGLE, {buildingId: buildingId}))
  }

  if (!selectedBuilding) {
    return null
  }

  return (
    <div style={PageContainer}>
      <PageHeader
        title={selectedBuilding.displayName}
        hideTrademark={true}
        titleIcon={
          <IconButton className={classes.backButton} onClick={() => history.push(Routes.ADMIN_DASHBOARD_DOCUMENTS_BY_BUILDING)}>
            <RXRIcon icon={RXRIcon.ARROW_LEFT} size={iconSizeLarge} />
          </IconButton>
        }
        rightControlComponent={
          <RXRButton
            onClick={() =>
              history.push(generatePath(Routes.ADMIN_DASHBOARD_DOCUMENTS_CREATE_BY_BUILDING_VIEW_SINGLE, {buildingId: buildingId}))
            }
          >
            Add new
          </RXRButton>
        }
      >
        <div className={classes.searchDocumentsContainer}>
          <ClearableInput value={filterTerm} onChange={setFilterTerm} placeholder={'Search documents'} />
        </div>
      </PageHeader>
      <div style={{flex: 1}}>
        <ListDocumentsAtBuildingTable
          buildingId={buildingId}
          filterTerm={filterTerm}
          handleClickDocument={dId =>
            history.push(
              generatePath(Routes.ADMIN_DASHBOARD_DOCUMENTS_VIEW_SINGLE_BY_BUILDING_VIEW_SINGLE, {buildingId: buildingId, documentId: dId}),
            )
          }
        />
      </div>

      <SidePanel
        isOpen={!!(focusedDocumentId || isCreateMode)}
        onClose={closeSidePanel}
        title={focusedDocumentId ? 'Edit document' : 'Create new document'}
      >
        <CreateOrEditDocument
          preSelectBuildingId={buildingId}
          documentId={focusedDocumentId}
          onSave={closeSidePanel}
          onCancel={closeSidePanel}
          onDelete={closeSidePanel}
        />
      </SidePanel>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  searchDocumentsContainer: {
    paddingBottom: spaceMedium,
    ...SearchBoxContainer,
  },

  backButton: {
    ...iconButton,
    height: iconButtonSizeLarge,
    width: iconButtonSizeLarge,
  },
}))

export default ResidentAppDocuments
